import { createContext, useContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';
import type { MeResponse, MembershipSummary, Profile } from '@adop/shared';

export interface AuthContextValue {
  session: Session | null;
  user: User | null;
  me: MeResponse | null;
  profile: Profile | null;
  memberships: MembershipSummary[];
  loading: boolean;
  error: string | null;
  signInWithGoogle: () => Promise<void>;
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
}
